module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerpt0101",
      "epub:type": "part",
      "id": "pt01",
      "role": "doc-part"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerpt0101"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "36",
      "id": "p36",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "37",
      "id": "p37",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0007#toc"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_vm._v("The Depths")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0101"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "38",
      "id": "p38",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "401",
      "src": "images/chi-crosson-fig01001.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 1.1.")]), _vm._v(" Funeral procession for one of the victims of the police shootings, along the edge of the abandoned cane fields in Rio Moro. Photograph by the author, 2011.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-105cc188","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-crosson-0010.vue
// module id = 81
// module chunks = 0